// The backend resolves a complete BO reference through the ERP filter, never
// through the numeric parent-id filter. Keep all other input semantics intact.
export function mapPedidoSearch(filters, parentKey, erpKey) {
  if (!filters || typeof filters !== 'object') return filters;
  const result = { ...filters };
  const value = String(result[parentKey] == null ? '' : result[parentKey]).trim();
  if (/^[A-Z0-9-]+BO\d+$/i.test(value)) {
    result[erpKey] = value.toUpperCase();
    delete result[parentKey];
  }
  return result;
}